export default "__VITE_ASSET__CrNfJ4Vh__"